/**
 * 公告信息
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import NoticeEdit from './NoticeEdit';
import DictSelect from '../../ui/DictSelect';
import { global_data } from '../../ui/auth'

class NoticeIndex extends React.Component {
    columns = [{
        title: '公告标题',
        dataIndex: 'title',
        width: '10%',
    }, {
        title: '公告类型',
        dataIndex: 'typeStr',
        width: '10%',
    }, {
        title: '显示顺序',
        dataIndex: 'sequence',
        width: '10%',
    }, {
        title: '有效期开始时间',
        dataIndex: 'startValidity',
        width: '10%',
    }, {
        title: '有效期结束时间',
        dataIndex: 'endValidity',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("SYS_NOTICE_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("SYS_NOTICE_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
                </Tooltip>
                :""}
            </div>
        ),
    }];

    state = {
        visible: false,
        editData: {},  //编辑的数据
        loadData: '',
        queryData: {}, //查询数据
    };

    add = () => {
        this.setState({ visible: true, editData: {} });
    }

    update = (info, e) => {
        this.setState({ visible: true, editData: info});
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
        
    }

    delete = (info, e) => {
        messager.confirm("是否删除该公告信息？", () => {
            http.post({
                url: '/notice/deleteNotice',
                data: { id: info },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    //查询
    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    selectChange = (value) => {
        let queryData = this.state.queryData;
        queryData.type = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="公告标题"
                                    onSearch={this.inputSearch.bind(this, "title")}
                                    enterButton
                                    style={{ width: '250px', marginRight: '10px' }}
                                />
                                <DictSelect category="NOTICE_TYPE"  allowClear={true} style={{ width: 120, margin: '0 10px'}} onChange={this.selectChange}/>
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("SYS_NOTICE_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/notice/findNoticePage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <NoticeEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }

}

export default NoticeIndex;